import { Link } from "gatsby-plugin-react-i18next";
import React, { FunctionComponent } from "react";
import { twMerge } from "tailwind-merge";

interface LinkCtaProps {
  to?: string;
  text: string;
  align?: "left" | "right" | "center";
  color?: string;
  target?: string;
}

const LinkCta: FunctionComponent<LinkCtaProps> = ({
  to,
  text,
  align = "left",
  color = "text-primary",
  target,
}) => {
  const alignment = {
    left: "",
    right: "text-right",
    center: "text-center",
  }[align];

  const classes = twMerge(
    `text-sm tracking-widest font-bold uppercase hover:underline block`,
    alignment,
    color,
  );
  const content = `${text} →`;

  return to ? (
    <Link to={to} className={classes} target={target}>
      {content}
    </Link>
  ) : (
    <p className={classes}>{content}</p>
  );
};

export { LinkCta };
